import { ReactComponent as ActiveDirectory } from "../../../../assets/icons/libraryIcons/active_directory.svg";
import { ReactComponent as Browser } from "../../../../assets/icons/libraryIcons/browser.svg";
import { ReactComponent as Recorder } from "../../../../assets/icons/libraryIcons/recorder.svg";
import { ReactComponent as Chatbot } from "../../../../assets/icons/libraryIcons/chatbot.svg";
import { ReactComponent as DisplayMessage } from "../../../../assets/icons/libraryIcons/display_message.svg";
import { ReactComponent as Condition } from "../../../../assets/icons/libraryIcons/condition.svg";
import { ReactComponent as Repeatable } from "../../../../assets/icons/libraryIcons/repeatable.svg";
import { ReactComponent as Grouping } from "../../../../assets/icons/libraryIcons/step.svg";
import { ReactComponent as Excel } from "../../../../assets/icons/libraryIcons/excel.svg";
import { ReactComponent as Word } from "../../../../assets/icons/libraryIcons/word.svg";
import { ReactComponent as Xml } from "../../../../assets/icons/libraryIcons/xml.svg";
import { ReactComponent as Pdf } from "../../../../assets/icons/libraryIcons/file.svg";
import { ReactComponent as File } from "../../../../assets/icons/libraryIcons/file.svg";
import { ReactComponent as Folder } from "../../../../assets/icons/libraryIcons/folder.svg";
import { ReactComponent as Os } from "../../../../assets/icons/libraryIcons/os.svg";
import { ReactComponent as Database } from "../../../../assets/icons/libraryIcons/database.svg";
import { ReactComponent as Email } from "../../../../assets/icons/libraryIcons/email.svg";
import { ReactComponent as Sap } from "../../../../assets/icons/libraryIcons/sap.svg";
import { ReactComponent as Ocr } from "../../../../assets/icons/libraryIcons/ocr.svg";
import { ReactComponent as ServiceDeskPlus } from "../../../../assets/icons/libraryIcons/service_desk_plus.svg";
import { ReactComponent as Ews } from "../../../../assets/icons/libraryIcons/ews.svg";
import { ReactComponent as RestfulWebService } from "../../../../assets/icons/libraryIcons/restful_web_service.svg";
import { ReactComponent as TimeManagement } from "../../../../assets/icons/libraryIcons/time_management.svg";
import { ReactComponent as DataTable } from "../../../../assets/icons/libraryIcons/data_table.svg";
import { ReactComponent as String } from "../../../../assets/icons/libraryIcons/string.svg";
import { ReactComponent as Number } from "../../../../assets/icons/libraryIcons/number.svg";
import { ReactComponent as Array } from "../../../../assets/icons/libraryIcons/array.svg";
import { ReactComponent as Dictionary } from "../../../../assets/icons/libraryIcons/dictionary.svg";
import { ReactComponent as Object } from "../../../../assets/icons/libraryIcons/object.svg";
import { ReactComponent as Data } from "../../../../assets/icons/libraryIcons/database.svg";
import { ReactComponent as Automs } from "../../../../assets/icons/libraryIcons/automs.svg";
import { ReactComponent as Models } from "../../../../assets/icons/libraryIcons/models.svg";
import { ReactComponent as PreProcessing } from "../../../../assets/icons/libraryIcons/pre_processing.svg";
import { ReactComponent as Predict } from "../../../../assets/icons/libraryIcons/predict.svg";
import { ReactComponent as Python } from "../../../../assets/icons/libraryIcons/python.svg";
import { ReactComponent as DateLib } from "../../../../assets/icons/libraryIcons/datelib.svg";
import { ReactComponent as Powershell } from "../../../../assets/icons/libraryIcons/powershell.svg";
import { ReactComponent as CsvText } from "../../../../assets/icons/libraryIcons/csv.svg";
import { ReactComponent as Whatsapp } from "../../../../assets/icons/libraryIcons/whatsapp.svg";
import StopIcon from "@material-ui/icons/Stop";
import PlayArrow from "@material-ui/icons/PlayArrow";
import active_directory from "../../../../assets/icons/libraryIcons/active_directory.svg";
import browser from "../../../../assets/icons/libraryIcons/browser.svg";
import recorder from "../../../../assets/icons/libraryIcons/recorder.svg";
import chatbot from "../../../../assets/icons/libraryIcons/chatbot.svg";
import display_message from "../../../../assets/icons/libraryIcons/display_message.svg";
import condition from "../../../../assets/icons/libraryIcons/condition.svg";
import repeatable from "../../../../assets/icons/libraryIcons/repeatable.svg";
import grouping from "../../../../assets/icons/libraryIcons/step.svg";
import excel from "../../../../assets/icons/libraryIcons/excel.svg";
import word from "../../../../assets/icons/libraryIcons/word.svg";
import xml from "../../../../assets/icons/libraryIcons/xml.svg";
import pdf from "../../../../assets/icons/libraryIcons/file.svg";
import file from "../../../../assets/icons/libraryIcons/file.svg";
import folder from "../../../../assets/icons/libraryIcons/folder.svg";
import os from "../../../../assets/icons/libraryIcons/os.svg";
import database from "../../../../assets/icons/libraryIcons/database.svg";
import email from "../../../../assets/icons/libraryIcons/email.svg";
import sap from "../../../../assets/icons/libraryIcons/sap.svg";
import ocr from "../../../../assets/icons/libraryIcons/ocr.svg";
import service_desk_plus from "../../../../assets/icons/libraryIcons/service_desk_plus.svg";
import ews from "../../../../assets/icons/libraryIcons/ews.svg";
import restful_web_service from "../../../../assets/icons/libraryIcons/restful_web_service.svg";
import time_management from "../../../../assets/icons/libraryIcons/time_management.svg";
import data_table from "../../../../assets/icons/libraryIcons/data_table.svg";
import string from "../../../../assets/icons/libraryIcons/string.svg";
import number from "../../../../assets/icons/libraryIcons/number.svg";
import array from "../../../../assets/icons/libraryIcons/array.svg";
import dictionary from "../../../../assets/icons/libraryIcons/dictionary.svg";
import object from "../../../../assets/icons/libraryIcons/object.svg";
import data from "../../../../assets/icons/libraryIcons/database.svg";
import automs from "../../../../assets/icons/libraryIcons/automs.svg";
import models from "../../../../assets/icons/libraryIcons/models.svg";
import pre_processing from "../../../../assets/icons/libraryIcons/pre_processing.svg";
import predict from "../../../../assets/icons/libraryIcons/predict.svg";
import python from "../../../../assets/icons/libraryIcons/python.svg";
import date_lib from "../../../../assets/icons/libraryIcons/datelib.svg";
import powershell from "../../../../assets/icons/libraryIcons/powershell.svg";
import csv_text from "../../../../assets/icons/libraryIcons/csv.svg";
import whatsapp from "../../../../assets/icons/libraryIcons/whatsapp.svg";
import flashOn from "../../../../assets/icons/libraryIcons/trigger-static-icon.svg";
import "./midSection/styles.css";
import { FlashOn } from "@material-ui/icons";

export const libraryIcons = {
    active_directory: <ActiveDirectory className="flow-item-img" />,
    browser: <Browser className="flow-item-img" />,
    recorder: <Recorder className="flow-item-img" />,
    desktop_actions: <Recorder className="flow-item-img" />,
    chatbot: <Chatbot className="flow-item-img" />,
    display_message: <DisplayMessage className="flow-item-img" />,
    condition: <Condition className="flow-item-img" />,
    repeatable: <Repeatable className="flow-item-img" />,
    grouping: <Grouping className="flow-item-img" />,
    excel: <Excel className="flow-item-img" />,
    word: <Word className="flow-item-img" />,
    csv_text: <CsvText className="flow-item-img" />,
    xml: <Xml className="flow-item-img" />,
    pdf: <Pdf className="flow-item-img" />,
    file: <File className="flow-item-img" />,
    folder: <Folder className="flow-item-img" />,
    os: <Os className="flow-item-img" />,
    database: <Database className="flow-item-img" />,
    email: <Email className="flow-item-img" />,
    sap: <Sap className="flow-item-img" />,
    ocr: <Ocr className="flow-item-img" />,
    service_desk_plus: <ServiceDeskPlus className="flow-item-img" />,
    ews: <Ews className="flow-item-img" />,
    restful_web_service: <RestfulWebService className="flow-item-img" />,
    time_management: <TimeManagement className="flow-item-img" />,
    data_table: <DataTable className="flow-item-img" />,
    string: <String className="flow-item-img" />,
    number: <Number className="flow-item-img" />,
    array: <Array className="flow-item-img" />,
    dictionary: <Dictionary className="flow-item-img" />,
    object: <Object className="flow-item-img" />,
    data: <Data className="flow-item-img" />,
    automs: <Automs className="flow-item-img" />,
    model: <Models className="flow-item-img" />,
    pre_processing: <PreProcessing className="flow-item-img" />,
    predict: <Predict className="flow-item-img" />,
    endpoint: <Automs className="flow-item-img" />,
    python: <Python className="flow-item-img" />,
    date: <DateLib className="flow-item-img" />,
    powershell: <Powershell className="flow-item-img" />,
    start: <PlayArrow />,
    stop: <StopIcon />,
    // trigger_static: <FlashOn />,
    trigger_static: <img src={flashOn} />,
    whatsapp: <Whatsapp className="flow-item-img" />
}
export const libraryIconsDrag = {
    active_directory,
    browser,
    recorder,
    desktop_actions: recorder,
    chatbot,
    display_message,
    condition,
    repeatable,
    grouping,
    excel,
    word,
    csv_text,
    xml,
    pdf,
    file,
    folder,
    os,
    database,
    email,
    sap,
    ocr,
    service_desk_plus,
    ews,
    restful_web_service,
    time_management,
    data_table,
    string,
    number,
    array,
    dictionary,
    object,
    data,
    automs,
    model: models,
    pre_processing,
    predict,
    endpoint: automs,
    python,
    date: date_lib,
    powershell,
    whatsapp
}
